import React, { useState } from 'react';
import { useAddCalendarMeetingActionsMutation } from '../../api/calendar.js';
import BaseOverlay from '../../components/layout/BaseOverlay.jsx';
import BaseButton from '../form/BaseButton.jsx';
import AfterMeetingStep4 from './AfterMeetingStep4.jsx';
import BaseCard from './BaseCard.jsx';

const AfterMeetingStep3 = ({ meetingId, calendarMeeting, showSecondOverlay }) => {
    const [message, setMessage] = useState(calendarMeeting?.actions || '');
    const [showThirdOverlay, setShowThirdOverlay] = useState(false);
    const [addCalendarMeetingActions, { isLoading }] = useAddCalendarMeetingActionsMutation();

    const handleNext = async () => {
        const trimmedMessage = message.trim() === '' ? '' : message.trim();

        const formattedMessage = { message: trimmedMessage };

        try {
            await addCalendarMeetingActions({ id: meetingId, data: formattedMessage });
        } catch (err) {
            console.error('Failed to send follow-up actions:', err);
        }

        setShowThirdOverlay(true);
    };

    return (
        <>
            <BaseOverlay show={showSecondOverlay} className='overflow-auto h-[100dvh] rounded-none'>
                <div className='min-h-96 max-w-3xl w-full mx-auto px-8'>
                    <div className='flex items-center gap-[12px] mt-10'>
                        <div className='rounded-full bg-theme1-primary w-[36px] h-[36px] flex items-center justify-center text-white text-xl'>
                            3
                        </div>
                        <div>
                            <h4 className='font-bold text-base'>Step 3</h4>
                            <p className='text-sm text-theme1-title2'>Follow Up Actions</p>
                        </div>
                    </div>
                    <BaseCard className='mt-6 mb-6 p-4 bg-theme1-white'>
                        <textarea
                            className={`w-full px-4 py-3 rounded-lg h-[250px] focus:outline-none bg-transparent ${
                                isLoading ? 'text-gray-400' : 'text-theme1-text1'
                            }`}
                            placeholder='Define your follow up actions'
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            disabled={isLoading}
                        />
                    </BaseCard>
                    <BaseButton
                        className='mt-4 mb-5 btn-red-outline'
                        textValue={isLoading ? 'Updating actions...' : 'Next'}
                        onClick={handleNext}
                        disabled={isLoading}
                    />
                </div>
            </BaseOverlay>
            <MemoizedAfterMeetingStep4 meetingId={meetingId} showThirdOverlay={showThirdOverlay} />
        </>
    );
};

const MemoizedAfterMeetingStep4 = React.memo(AfterMeetingStep4);

export default AfterMeetingStep3;
